
import { defineComponent } from 'vue';
import { mapGetters } from 'vuex';
import { MortalityResults } from '@smartplus/components';

export default defineComponent({
  name: 'MortalityAnalysis',
  components: {
    MortalityResults,
  },
  computed: {
    ...mapGetters('mortalityAnalysis', {
      MortalityAnalysis: 'getAnalysis',
      AnalysisLoading: 'getAnalysisLoading',
      Household: 'getHousehold',
    }),
  },
});
